<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormTimbradoCertificado" role="form" method="post" autocomplete="off" onSubmit="return false">
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="NumCertificado">Número de Certificado</label>
							<input type="text" v-model="objTimbradoCertificado.NumCertificado" class="form-control" id="NumCertificado" placeholder="Ingresar Número de Certificado" />
							<CValidation v-if="this.errorvalidacion.NumCertificado" :Mensaje="'*'+errorvalidacion.NumCertificado[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Contrasenia">Contraseña</label>
							<input type="text" v-model="objTimbradoCertificado.Contrasenia" class="form-control" id="Contrasenia" placeholder="Ingresar Contraseña" />
							<CValidation v-if="this.errorvalidacion.Contrasenia" :Mensaje="'*'+errorvalidacion.Contrasenia[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="LlaveDeCancelacion">Llave De Cancelacion</label>
							<textarea v-model="objTimbradoCertificado.LlaveDeCancelacion" class="form-control" id="LlaveDeCancelacion" placeholder="Ingresar Llave De Cancelación" rows="6"></textarea>
							<CValidation v-if="this.errorvalidacion.LlaveDeCancelacion" :Mensaje="'*'+errorvalidacion.LlaveDeCancelacion[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="ArchivoCertificado">Archivo Certificado</label>
							<input type="text" v-model="objTimbradoCertificado.ArchivoCertificado" class="form-control" id="ArchivoCertificado" placeholder="Ingresar Archivo Certificado" />
							<CValidation v-if="this.errorvalidacion.ArchivoCertificado" :Mensaje="'*'+errorvalidacion.ArchivoCertificado[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="ArchivoPem">Archivo Pem</label>
							<input type="text" v-model="objTimbradoCertificado.ArchivoPem" class="form-control" id="ArchivoPem" placeholder="Ingresar Archivo Pem" />
							<CValidation v-if="this.errorvalidacion.ArchivoPem" :Mensaje="'*'+errorvalidacion.ArchivoPem[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormTimbradoCertificado',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objTimbradoCertificado: {
				IdTimbradoCertificado: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				NumCertificado: '',
				Contrasenia: '',
				LlaveDeCancelacion: '',
				ArchivoCertificado: '',
				ArchivoPem: '',
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
        }
    },
    methods :
    {
       	async Guardar()
        {
			let formData = new FormData();
            /* let Imagen = this.$refs.fileImg.files[0];

            if(Imagen === undefined && this.objBancoImagen.IdBancoImagen == 0){
                this.$toast.warning('Debe agregar una imagen');
                return false;
            } */

			formData.set('IdTimbradoCertificado', this.objTimbradoCertificado.IdTimbradoCertificado);
			formData.set('IdEmpresa', this.objTimbradoCertificado.IdEmpresa);
			formData.set('IdSucursal', this.objTimbradoCertificado.IdSucursal);
			formData.set('NumCertificado', this.objTimbradoCertificado.NumCertificado);
			formData.set('Contrasenia', this.objTimbradoCertificado.Contrasenia);
			formData.set('LlaveDeCancelacion', this.objTimbradoCertificado.LlaveDeCancelacion);
			formData.set('ArchivoCertificado', this.objTimbradoCertificado.ArchivoCertificado);
			formData.set('ArchivoPem', this.objTimbradoCertificado.ArchivoPem);

			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			await this.$http.post('timbradoCertificados', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "timbradoCertificados/"+this.objTimbradoCertificado.IdSucursal
            ).then((res) => {

				if(res.data.noData == 1){
                	this.objTimbradoCertificado = res.data.data;
				}

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objTimbradoCertificado = {
				IdTimbradoCertificado: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				NumCertificado: '',
				Contrasenia: '',
				LlaveDeCancelacion: '',
				ArchivoCertificado: '',
				ArchivoPem: '',
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(obj)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();

			this.objTimbradoCertificado.IdEmpresa = obj.IdEmpresa;
			this.objTimbradoCertificado.IdSucursal = obj.IdSucursal;
			this.Recuperar();
        });
    }
}
</script>
